import { Controller } from "@hotwired/stimulus";

let listening = false;

const scrollElement = document.getElementById("main-scroll") || window;

const clearBoxes = () => {
  document.querySelectorAll("[data-remove-on-mouse-out]").forEach((element) => {
    element.parentElement.removeChild(element);
  });
  if (listening) {
    listening = false;
    scrollElement.removeEventListener("scroll", clearBoxes);
  }
};

export default class extends Controller {
  static targets = ["content"];

  connect() {
    this.element.addEventListener("mouseover", this.onMouseOver);
    this.element.addEventListener("mouseout", clearBoxes);
    this.element.addEventListener("click", this.onMouseOut);
  }

  onClick = (e) => {
    if (e.target.closest("a")) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
  };

  onMouseOver = async (e) => {
    if (!listening) {
      listening = true;
      scrollElement.addEventListener("scroll", clearBoxes);
    }

    const content = this.contentTarget;
    const cloneContent = content.cloneNode(true);
    cloneContent.dataset.removeOnMouseOut = true;

    document.body.appendChild(cloneContent);

    await new Promise((resolve) => requestAnimationFrame(resolve));

    let { top, left, bottom: elementBottom } = this.element.getBoundingClientRect();

    const targetLeft = left + this.element.clientWidth / 2;

    const fromBottom = window.innerHeight - top;

    const contentWidth = cloneContent.clientWidth;
    const contentHeight = cloneContent.clientHeight;

    const remSize = window.remToPx(1);

    let cloneLeft = targetLeft - contentWidth / 2;

    let dCaret = 0;

    if (cloneLeft < remSize) {
      dCaret = cloneLeft - remSize;
      cloneLeft = remSize;
    }

    if (cloneLeft + contentWidth > window.innerWidth - remSize) {
      dCaret = cloneLeft + contentWidth - (window.innerWidth - remSize);
      cloneLeft = window.innerWidth - contentWidth - remSize;
    }

    cloneContent.style.left = `${cloneLeft}px`;

    const caret = cloneContent.querySelector("[data-order-hover-box-caret]");

    const caretLeft = dCaret - 0 + contentWidth / 2;

    caret.style.left = `${caretLeft}px`;

    const isOver = top - contentHeight > remSize;

    if (isOver) {
      cloneContent.classList.remove("tw:top-0");
      cloneContent.style.bottom = `${fromBottom + remSize}px`;
      caret.style.top = `${contentHeight - remSize * 0}px`;
    } else {
      cloneContent.style.top = `${elementBottom + remSize}px`;
      caret.style.bottom = `${contentHeight - remSize * 1}px`;
    }

    cloneContent.classList.remove("tw:invisible");
  };
}
